<div class="property-details-photo" [class.no-photo]="!currentPhotoUrl">
  <div *ngIf="currentPhotoUrl" class="property-photo-overlay">
    <div class="photo-edit-buttons">
      <button
        (click)="deletePhoto()"
        (mouseenter)="showElement(deletePhotoLabel)"
        (mouseleave)="hideElement(deletePhotoLabel)"
        (focus)="showElement(deletePhotoLabel)"
        (blur)="hideElement(deletePhotoLabel)"
        id="btn-supprimer-photo"
      >
        <img
          src="{{ 'assets/images/propriete/poubelle.svg' | cheminAbsoluStatique }}"
          class="delete-photo-icon"
          [alt]="'propriete.photo.supprimer-photo' | translate"
        />
      </button>

      <button
        (click)="openFileBrowser()"
        (mouseenter)="showElement(editPhotoLabel)"
        (mouseleave)="hideElement(editPhotoLabel)"
        (focus)="showElement(editPhotoLabel)"
        (blur)="hideElement(editPhotoLabel)"
        id="btn-modifier-photo"
      >
        <img
          src="{{ 'assets/images/propriete/camera-bicolore.svg' | cheminAbsoluStatique }}"
          class="edit-photo-icon"
          [alt]="'propriete.photo.modifier-photo' | translate"
        />
      </button>
    </div>
    <label #editPhotoLabel>{{ 'propriete.photo.modifier-photo' | translate }}</label>
    <label #deletePhotoLabel>{{ 'propriete.photo.supprimer-photo' | translate }}</label>
  </div>

  <img *ngIf="currentPhotoUrl" class="property-photo" [src]="currentPhotoUrl" alt="" />

  <button
    *ngIf="!currentPhotoUrl"
    class="add-photo-button text-only-button"
    (click)="openFileBrowser()"
    id="btn-ajouter-photo"
  >
    <img
      src="{{ 'assets/images/propriete/camera-bicolore.svg' | cheminAbsoluStatique }}"
      width="31"
      height="25"
      alt=""
    />
    <span>{{ 'propriete.photo.ajouter-photo' | translate }}</span>
  </button>
</div>

<app-edit-photo (savePhoto)="handlePhotoUpload($event)"></app-edit-photo>
